import React, { useState, useEffect } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { getBalanceNumber } from 'utils/formatBalance'
import { useTranslation } from 'contexts/Localization'
import { Flex, MetamaskIcon, Text, LinkExternal, TimerIcon, Skeleton, useTooltip, Button } from '@pixel-nft/uikit'
import { getPIXELPoolContract } from 'utils/contractHelpers'
import useWeb3 from 'hooks/useWeb3'
import { BASE_BSC_SCAN_URL, BASE_URL, DEFAULT_TOKEN_DECIMAL } from 'config'
import { useBlock } from 'state/hooks'
import { LendingPool, Pool } from 'state/types'
import { getAddress } from 'utils/addressHelpers'
import { registerToken } from 'utils/wallet'
import Balance from 'components/Balance'

const ExpandedWrapper = styled(Flex)`
  /* svg {
    height: 14px;
    width: 14px;
  } */
`

const StyledLinkExternal = styled(LinkExternal)`
  color: white;
  font-weight: 400;
`

const ExpandedFooter: React.FC<{
  tokenAddress: string
}> = ({ tokenAddress }) => {
  const WEB3 = useWeb3()
  const isBscScan = process.env.REACT_APP_CHAIN_ID === '56'
  const bscScanAddress = isBscScan
    ? `${BASE_BSC_SCAN_URL}/token/${tokenAddress}`
    : `https://testnet.bscscan.com/token/${tokenAddress}`

  return (
    <ExpandedWrapper flexDirection="column">
      <Flex mb="2px" justifyContent="space-between" alignItems="center">
        <Text small>Deposit:</Text>
        <StyledLinkExternal href={BASE_URL}>USDT</StyledLinkExternal>
      </Flex>
      <Flex justifyContent="flex-end">
        <StyledLinkExternal small href={bscScanAddress}>
          View BSC Scan
        </StyledLinkExternal>
      </Flex>
    </ExpandedWrapper>
  )
}

export default React.memo(ExpandedFooter)
